import { Component, ViewContainerRef, TemplateRef } from '@angular/core';
import { Category } from '../../../models/category/category.model';
import { CategoryService } from '../../../services/category/category.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { RolePermissionService } from '../../../services/role/role-permission.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MediaLibraryService } from '../../../services/mediaLibrary/media-library.service';
import { MediaLibrary } from '../../../models/mediaLibrary/media-library-model';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { DisplayCategory } from '../../../models/category/DisplayCategory.model';
@Component({
  selector: 'app-create-parent-category',
  templateUrl: './create-parent-category.component.html',
  styleUrls: ['./create-parent-category.component.css']
})
/** create-parent-category component*/
export class CreateParentCategoryComponent {
  parentCategory = new Category();
  fileToUpload: File;
  fd = new FormData();
  public parentCategoryList: Category[];
  public categoryList: Category[];
  public isCategoryExist: boolean;
  public duplicateCategory: string;
  public websiteName: string;
  public htmlContent: any;
  public mediaList: MediaLibrary[];
  selectedTinLogo: string;
  selectedSmallLogo: string;
  selectedLargeTinLogo: string;
  selectIamge: string;
  mediaImageShow: boolean;
  selectedTinyImage: string;
  selectedSmallImage: string;
  selectedLargeImage: string;
  modalRef: BsModalRef;
  config = {
    animated: true
  };
  configuration = {
    uiColor: '#ffffff',
    toolbarGroups: [{ name: 'clipboard', groups: ['clipboard', 'undo'] },
    { name: 'editing', groups: ['find', 'selection', 'spellchecker'] },
    { name: 'links' }, { name: 'insert' },
    { name: 'document', groups: ['mode', 'document', 'doctools'] },
    { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
    { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align'] },
    { name: 'styles' },
    { name: 'colors' }],
    resize_enabled: false,
    removePlugins: 'save',
    extraPlugins: 'smiley,justify,indentblock,colordialog',
    colorButton_foreStyle: {
      element: 'font',
      attributes: { 'color': '#(color)' }
    },
    height: 188,
    removeDialogTabs: '',
    removeButtons: '',
    format_tags: 'p;h1;h2;h3;pre;div'
  }
  /** create-parent-category ctor */
  constructor(private readonly categoryService: CategoryService,
    private readonly toastr: ToastsManager, vcr: ViewContainerRef, private readonly router: Router, private readonly rolePermissionService: RolePermissionService,
    private readonly mediaServices: MediaLibraryService, private modalService: BsModalService) {
    this.checkPermission();
    this.toastr.setRootViewContainerRef(vcr);
    this.parentCategory.isActive = true;
    this.parentCategory.justForU = false;
    this.parentCategory.parentCategoryID = 0;
    this.GetParentCategoryList();
    this.GetCategoryList();
    this.isCategoryExist = false;
    this.GetSystemSettingFirstOrDefault();
    this.parentCategory.metaTitle = "";
    this.parentCategory.metaDescription = "";
    this.parentCategory.metaTag = "";
    this.mediaImageShow = true;
    this.selectIamge = "";
  }
  checkPermission() {
    this.rolePermissionService.GetRolePermissions("parentcategory").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });

          if (create.length > 0) {

          }
          else {
            this.router.navigate(["/Parent-Category-List"]);
          }
        }
        else {
          this.router.navigate(["/Parent-Category-List"]);
        }
      }
    )
  }
  uploadTinyImage(file: FileList) {
    this.fileToUpload = file.item(0);
    this.fd.append("TinyImage", this.fileToUpload);
    this.selectedTinLogo = "";
    var reader = new FileReader();
    reader.onload = (event: any) => {
      this.parentCategory.tinyImage = "";
      this.selectedTinyImage = event.target.result;
    }
  }
  uploadSmallImage(file: FileList) {
    this.fileToUpload = file.item(0);
    this.fd.append("SmallImage", this.fileToUpload);
    this.selectedSmallLogo = "";
    var reader = new FileReader();
    reader.onload = (event: any) => {
      this.parentCategory.smallImage = "";
      this.selectedSmallImage = event.target.result;
    }
  }
  uploadLargeImage(file: FileList) {
    this.fileToUpload = file.item(0);
    this.fd.append("LargeImage", this.fileToUpload);
    this.selectedLargeTinLogo = "";
    var reader = new FileReader();
    reader.onload = (event: any) => {
      this.parentCategory.largeImage = "";
      this.selectedLargeImage = event.target.result;
    }
  }

  //isParentCheckbox(e) {
  //  this.parentCategory.isParent = e.target.checked;
  //}
  GetParentCategoryList() {
    this.categoryService.GetCategoryList().subscribe(
      data => {
        this.parentCategoryList = data;
      });
  }
  GetCategoryList() {
    this.categoryService.GetCategoryListUnderParent().subscribe(
      data => {
        this.categoryList = data;
      });
  }
  GetSystemSettingFirstOrDefault() {
    this.categoryService.GetSystemSettingFirstOrDefault().subscribe(
      data => {
        this.websiteName = data.siteUrl;
      });
  }
  onTextChange(Value: string) {

    var i = 0, strLength = Value.length;
    for (i; i < strLength; i++) {
      Value = Value.replace(" ", "-");
    }
    this.parentCategory.url = Value.toLowerCase();



  }
  OnFocusOut() {
    if (this.parentCategory.categoryName.length > 0) {
      this.duplicateCategory = this.parentCategory.categoryName;
      // passing model instead of parameters due to special charactors issue in paramater 'categoryName'
      let categoryParams = new DisplayCategory();
      categoryParams.categoryID = 0;
      categoryParams.categoryName = this.parentCategory.categoryName;
      categoryParams.parentCategoryID = this.parentCategory.parentCategoryID;
      this.categoryService.CheckCategoryNameExists(categoryParams).subscribe(
        data => {
          if (data == true) {
            this.isCategoryExist = true;
            this.parentCategory.categoryName = "";
            this.parentCategory.url = "";
          } else {
            this.isCategoryExist = false;
          }
        });
    }
  }

  onSubmit() {
    this.fd.append("CategoryName", this.parentCategory.categoryName);
    this.fd.append("IconClass", this.parentCategory.iconClass);
    this.fd.append("IsActive", this.parentCategory.isActive.toString());
    this.fd.append("JustForU", this.parentCategory.justForU.toString());
    this.fd.append("Url", this.parentCategory.url);
    //this.fd.append("Detail", this.parentCategory.detail);
    //this.fd.append("SortOrder", this.parentCategory.sortOrder.toString());
    if (this.htmlContent != null) {
      this.fd.append("Detail", this.htmlContent);
    } else {
      this.fd.append("Detail", "");
    }
    if (this.htmlContent != null) {
      this.fd.append("MetaTitle", this.parentCategory.metaTitle);
    }
    else {
      this.fd.append("MetaTitle", "");
    }
    if (this.htmlContent != null) {
      this.fd.append("MetaTag", this.parentCategory.metaTag);
    } else {
      this.fd.append("MetaTag", "");
    }
    if (this.htmlContent != null) {
      this.fd.append("MetaDescription", this.parentCategory.metaDescription);
    } else {
      this.fd.append("MetaDescription", "");
    }

    // decide if current saved category is "category" or "subcategory"
    let IsCategory = this.parentCategoryList.filter(item => item.categoryID == this.parentCategory.parentCategoryID).length > 0;
    let IsSubCategory = this.categoryList.filter(item => item.categoryID == this.parentCategory.parentCategoryID).length > 0;
    if (this.parentCategory.parentCategoryID == 0 || (IsCategory == true && IsSubCategory == false)) {
      this.parentCategory.isParent = true;
    } else if (IsCategory == false && IsSubCategory == true) {
      this.parentCategory.isParent = false;
    }
    this.fd.append("IsParent", this.parentCategory.isParent.toString());
    this.fd.append("ParentCategoryID", this.parentCategory.parentCategoryID.toString());
    this.toastr.success('Category saved successfully.', 'Success');
    this.categoryService.AddParentCategory(this.fd);
  }
  OpenMediaPopup(template: TemplateRef<any>, ImageFor: string, selectIamge: string) {
    this.selectIamge = selectIamge;
    this.mediaServices.getMediaLibraryFor(ImageFor).subscribe(
      data => {
        this.mediaList = data;
        if (this.mediaList.length > 0) {
          this.modalRef = this.modalService.show(template, { class: 'modal-lg' });
        }

      }
    )
  }
  SlectImage(Image: MediaLibrary) {
    this.fileToUpload = null;
    // this.mediaImageShow = true;
    if (this.selectIamge == "Tiny") {
      this.parentCategory.tinyImage = Image.fileName;
      this.fd.append("TinyImage", this.parentCategory.tinyImage);
      this.selectedTinyImage = "";
    }
    if (this.selectIamge == "Thumbnail") {
      this.parentCategory.smallImage = Image.fileName;
      this.fd.append("SmallImage", this.parentCategory.smallImage);
      this.selectedSmallImage = "";
    }
    if (this.selectIamge == "Banner") {
      this.parentCategory.largeImage = Image.fileName;
      this.fd.append("LargeImage", this.parentCategory.largeImage);
      this.selectedLargeImage = "";
    }
    this.mediaList.forEach(x => {
      x.activeDiv = false;
    });


    Image.activeDiv = !Image.activeDiv;
  }
  ShowImage() {
    //this.mediaImageShow = false;
    //this.selectedBlogLogo = "";
    this.modalRef.hide();
  }
  HidePopup() {
    if (this.selectIamge == "Tiny") {
      this.selectedTinyImage = "";
      this.parentCategory.tinyImage = "";
    }
    if (this.selectIamge == "Thumbnail") {
      this.parentCategory.smallImage = "";
      this.selectedSmallImage = "";
    }
    if (this.selectIamge == "Banner") {
      this.parentCategory.largeImage = "";
      this.selectedLargeImage = "";
    }
    this.modalRef.hide();
  }
}



// WEBPACK FOOTER //
// ./src/app/category-components/parent-category/create-parent-category/create-parent-category.component.ts